export const GET_TRUNK_STATISTICS = 'GET_TRUNK_STATISTICS'
export const GET_TRUNK_STATISTIC = 'GET_TRUNK_STATISTIC'
export const INITIAL_TRUNK_STATISTICS_DATA = 'INITIAL_TRUNK_STATISTICS_DATA'
export const GET_TRUNK_STATISTICS_PAGINATION = 'GET_TRUNK_STATISTICS_PAGINATION'
export const SET_CURRENT_TRUNK_STATISTICS_PAGE = 'SET_CURRENT_TRUNK_STATISTICS_PAGE'
export const SET_CURRENT_TRUNK_STATISTICS_SIZE = 'SET_CURRENT_TRUNK_STATISTICS_SIZE'
export const SET_TRUNK_STATISTICS_LOADING = 'SET_TRUNK_STATISTICS_LOADING'
export const SHOW_EXPORT_TRUNK_STATISTICS_LOADING = 'SHOW_EXPORT_TRUNK_STATISTICS_LOADING'
export const SET_TRUNK_STATISTICS_FILTER = 'SET_TRUNK_STATISTICS_FILTER'
export const CLEAR_TRUNK_STATISTICS_FILTERS = 'CLEAR_TRUNK_STATISTICS_FILTERS'
export const SET_TRUNK_STATISTICS_UI_FILTERS = 'SET_TRUNK_STATISTICS_UI_FILTERS'
export const UPDATE_TRUNK_STATISTIC_FILTER = 'UPDATE_TRUNK_STATISTIC_FILTER'
export const GET_TRUNK_STATISTICS_FILES_HISTORY = 'GET_TRUNK_STATISTICS_FILES_HISTORY'
export const SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER = 'SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER'
export const GET_TRUNK_STATISTICS_FILES_PAGINATION = 'GET_TRUNK_STATISTICS_FILES_PAGINATION'
export const SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE = 'SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE'
export const SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE = 'SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE'
